import { render, staticRenderFns } from "./CollapsibleSection.vue?vue&type=template&id=76e53005&scoped=true&"
import script from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CollapsibleSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CollapsibleSection.vue?vue&type=style&index=0&id=76e53005&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e53005",
  null
  
)

export default component.exports